import { getAllCookies, formatURL, cleanDate, isB2b, isSameDaySearch, getProductDiscount } from './../utils';
import dataLayer from './dataLayer';

const basePathPurchase = '/pedido';

export const sendToRDStation = async () => {
  try {
    let lead_mail,
      lead_name = '';

    const cookies = getAllCookies();
    for (const [key, value] of Object.entries(cookies)) {
      if (key.trim() === 'LeadEmail') {
        lead_mail = decodeURIComponent(value);
      }
      if (key.trim() === 'LeadName') {
        lead_name = decodeURIComponent(value);
      }
    }

    const response = await fetch('https://www.rdstation.com.br/api/1.3/conversions', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token_rdstation: '904297ddf27aa488461f1936e94791d6',
        identificador: 'spctaselecionarseguro',
        email: lead_mail,
        nome: lead_name,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      console.log('Response Data:', data);
      console.log('Success!');
    } else {
      console.log('Error: ', response.statusText);
    }
  } catch (error) {
    console.error('Fetch Error:', error);
  }
};

export const getProductPurchaseUrl = (match, code) => {
  const newUrl = formatURL(
    match.params,
    `${basePathPurchase}/${code}/${match.params.destination}/${cleanDate(match.params.begin_date)}/${cleanDate(
      match.params.end_date
    )}/`
  );

  return newUrl;
};

export function insertTagPurchaseUrl(url, newTag) {
  const [base, query] = url.split('?');
  const params = new URLSearchParams(query || '');

  const tags = params.getAll('tag');
  if (newTag) tags.push(newTag);

  params.delete('tag');
  const otherQuery = params.toString();

  if (tags.length) {
    const uniqueTags = Array.from(new Set(tags));
    const tagStr = `tag=${uniqueTags.join(',')}`;
    return `${base}?${otherQuery ? otherQuery + '&' : ''}${tagStr}`;
  }

  return `${base}?${otherQuery}`;
}

export const isPlanDisabled = (match, userDetails) => {
  return isSameDaySearch(match.params.begin_date) && !userDetails.operator_permissions;
};

export const getProductPlanUrl = (match, code) => {
  const basePath = isB2b() ? '/seguro-viagem/cobertura-b2b' : '/seguro-viagem/cobertura';

  const newUrl = formatURL(
    match.params,
    `${basePath}/${code}/${match.params.destination}/${cleanDate(match.params.begin_date)}/${cleanDate(
      match.params.end_date
    )}/`
  );

  return newUrl;
};

export const selectPlanAndRedirect = (productPurchaseUrl) => {
  dataLayer.raw({ event: 'page_pedido' });
  window.location.href = productPurchaseUrl;
};

export const calcCouponDiscount = (plan, coupon) => getProductDiscount(plan.price.adult.price, plan.code, coupon)

export const maxValueParcel = (price) => {
  const MAX_PARCELS = 12;
  const MIN_PARCEL_VALUE = 30.0;

  const parcels = Math.min(Math.floor(price / MIN_PARCEL_VALUE), MAX_PARCELS);

  return parcels;
};

export const isBenefitIncluded = (benefit) => {
  const coverage = ((benefit && benefit.coverage) || '').toString().trim().toUpperCase();
  const [prefix] = coverage.split('|').map((part) => part.trim());
  return prefix === 'SIM' || prefix === 'INCLUSO';
};

export const hasBenefitCode = (plan, code) =>
  ((plan && plan.benefits) || []).some(
    (benefit) => (benefit.code === code || benefit.code === Number(code)) && isBenefitIncluded(benefit)
  );



// WEBPACK FOOTER //
// ./src/utils/plan.js